import { AnalyticEventType } from './analytic.event.types';

interface AnalyticEventInterface {
  type: AnalyticEventType;
  category: string;
  action: string;
  label: string;
}

export class AnalyticEvent implements AnalyticEventInterface {
  type: AnalyticEventType;
  category: string;
  action: string;
  label: string;

  constructor(type: AnalyticEventType, category: string, action: string, label?: string) {
    this.type = type;
    this.category = category;
    this.action = action;
    this.label = label;
  }

  getType() {
    return this.type;
  }

  getCategory() {
    return this.category;
  }

  getAction() {
    return this.action;
  }

  getLabel() {
    return this.label || '';
  }
}

export class CustomDimensionEvent {
  Site: string;
  Product: string;
  Page_Flow: string;
  Reviews_Source: string;
  Reviews_Number?: string;
  Reviews_Total_Number?: string;

  constructor(
    Site: string,
    Product: string,
    Page_Flow: string,
    Reviews_Source: string,
    Reviews_Number?: string,
    Reviews_Total_Number?: string
  ) {
    this.Site = Site;
    this.Product = Product;
    this.Page_Flow = Page_Flow;
    this.Reviews_Source = Reviews_Source;
    this.Reviews_Number = Reviews_Number;
    this.Reviews_Total_Number = Reviews_Total_Number;
  }

  getSite() {
    return this.Site;
  }

  getProduct() {
    return this.Product;
  }

  getPageFlow() {
    return this.Page_Flow;
  }

  getReviewsSource() {
    return this.Reviews_Source;
  }

  getReviewsNumber() {
    return this.Reviews_Number;
  }

  getReviewsTotalNumber() {
    return this.Reviews_Total_Number;
  }
}
